import { render, staticRenderFns } from "./ColumnMapper.vue?vue&type=template&id=7677b668&lang=html&"
import script from "./ColumnMapper.vue?vue&type=script&lang=js&"
export * from "./ColumnMapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports